import { useTranslation } from 'react-i18next';

import { Div } from "ui"

import phoneIMG from 'assets/images/flixx/phone.png'
import { Text } from 'ui/index';
import OverlaySVG from './OverlaySVG'

const TextCard2 = (props) => {

  const { t } = useTranslation()

  return (
    <Div position='relative'>
      <Div
        position='absolute'
        top='40%'
        left='50%'
        transform='translateX(-50%)'
        width='100%'
        maxWidth={345}
        minWidth={290}
      >
        <OverlaySVG height='100%' width='100%' />

        <Div
          position='absolute'
          top='23%'
          left='21%'
        >
          <Text size='sm' color='headline'>{t('flixx_transfers_exampleName')}</Text>
        </Div>
        <Div
          position='absolute'
          top='46%'
          left='21%'
        >
          <Text size='sm'>{t('flixx_transfers_exampleDate')}</Text>
        </Div>
      </Div>


      <Div
        maxWidth={345}
        margin='0 auto'
      >
        <img
          height='100%'
          width='100%'
          src={`${phoneIMG}`}
          alt=''
        />
      </Div>
    </Div>
  )
}

export default TextCard2
